import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import ModalCovid from "../ModalCovid/ModalCovid";
import "./PageAnalyse.css";
import Select, { components } from "react-select";
import StepperComponent from "../Stepper/Stepper";
import ServiceMember from "../Services/ServiceMember";
import {
  formatAnalyseToLabelValue,
  formatAnalyseToObject,
} from "../../utils/utils";
import Navbar from "../Navbar/Navbar";
import ServiceProfile from "../../HomePage/PageHomeAdmin/Profile/Service/ServiceProfile";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

const PageAnalyse = (props) => {
  const profSante = JSON.parse(sessionStorage.getItem("profSante"));
  const [formattedanalyse, setFormattedAnalyse] = useState([]);
  const [analyse, setAnalyse] = useState([]);

  useEffect(() => {
    handleNext();
    setAnalyseItem();
  }, [analyse]);

  //Select
  useEffect(() => {
    GetAnalyse();
  }, []);

  const [activeStep, setActiveStep] = useState();
  const [type, setTaype] = useState(
    JSON.parse(sessionStorage.getItem("Type")) &&
      JSON.parse(sessionStorage.getItem("Type")).type
  );

  const handleNext = () => {
    setActiveStep(0);
  };

  const GetAnalyse = () => {
    if (type === "No Covid") {
      ServiceMember.getAnalyse().then((res) => {
        setFormattedAnalyse(res.data.map(formatAnalyseToLabelValue));
      });
    } else if (type === "Covid") {
      ServiceMember.getAnalyseCovid().then((res) => {
        setFormattedAnalyse(res.data.map(formatAnalyseToLabelValue));
      });
    } else {
      ServiceProfile.getServiceId(
        JSON.parse(sessionStorage.getItem("dataCabinet")) &&
          JSON.parse(sessionStorage.getItem("dataCabinet")).id
      ).then((res) => {
        setFormattedAnalyse(res.data.map(formatAnalyseToLabelValue));
      });
    }
  };

  const setAnalyseItem = () => {
    // const sessionAnalyse = JSON.parse(sessionStorage.getItem("analyse"));
    // const sessionAnalyseIds = JSON.parse(sessionStorage.getItem("analyseIds"));

    sessionStorage.setItem("analyse", JSON.stringify(analyse ? analyse : []));
    //set analyse Ids
    const ids = [];
    analyse.length &&
      analyse.map((row, i) => {
        ids.push({ id: row.value });
      });
    sessionStorage.setItem("analyseIds", JSON.stringify(ids));
  };

  // const postAnalyse = { id: analyse && analyse.value };

  const [show, setShow] = useState(false);
  const HandleShow = () => setShow(true);
  const Toggle = () => {
    setShow(false);
  };

  // get labo info
  const lieux = JSON.parse(sessionStorage.getItem("lieux"));

  return (
    <>
      <Navbar />
      <Container>
        <ModalCovid show={show} Toggle={Toggle} />

        <div className="analyse">
          <h2>Prise de rendez-vous en ligne</h2>
          <hr />
          <StepperComponent activeStep={activeStep} />
          <Row>
            <Col lg={6} xs={12}>
              <div className="div1">
                <p>
                  Veuillez choisir un à un les services figurant sur la liste .
                  N’écrivez qu’un seule service à la fois.
                </p>
                <Form.Label className="label">Nom du service :</Form.Label>
                <Select
                  className="select input-field"
                  width="90%"
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      padding: 5,
                      borderRadius: 5,
                      background: type === "Covid" ? "#c4e538" : "#2ecc71",
                      color: "white",
                      display: "flex",
                    }),
                  }}
                  components={{ SingleValue }}
                  isSearchable
                  isMulti
                  name="label"
                  options={formattedanalyse}
                  onChange={(formattedanalyse) => {
                    setAnalyse(formattedanalyse);
                  }}
                />
              </div>
            </Col>

            <Col lg={6} xs={12}>
              <div className="card2">
                {/* <img
                    src="https://img.icons8.com/fluent/48/000000/close-window.png"
                    onClick={() => clearAnalyse()}
                  /> */}
                {/* <h6>{analyse.designation}</h6> */}
                {/* <hr /> */}
                <Form.Check
                  className="checkbox"
                  type="checkbox"
                  label="Rendez-vous pour un enfant de 9 ans et moins?
                         Tout est là? Passez à la réservation."
                />
                <div style={{ display: "flex" }}>
                  <button
                    className="btn2 home"
                    style={{
                      width: "200px",
                      margin: "10px auto 20px",
                      background: type === "Covid" ? "#c4e538" : "#2ecc71",
                    }}
                    onClick={() => {
                      type === "Covid"
                        ? window.location.replace("/searchrdv")
                        : HandleShow();
                    }}
                  >
                    Prenez Rendez-Vous
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              <div className="card div1">
                <h4>Vous avez des questions?</h4>

                <p>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "#2ecc71",
                      float: "right",
                    }}
                  >
                    {profSante &&
                      `${profSante.firstName} ${profSante.lastName}`}
                  </span>
                  N'hésitez pas à appeler notre service à la clientèle. Du lundi
                  au vendredi entre 6 h et 18 h Le samedi entre 7 h 30 et 15 h
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "#2ecc71",
                      float: "right",
                    }}
                  >
                    {profSante && profSante.tel}
                  </span>
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default PageAnalyse;
